/**
 * @file Fixed Video
 */

import GLightbox from 'glightbox';

/**
 * Fixed Video component
 */
const vFixedVideo = () => {
	const fixedVideo = document.querySelector( '.v-fixed-video' );

	if ( ! fixedVideo ) {
		return;
	}

	let disableScroll = false;
	let lastScroll    = 0;

	/**
	 * Override Scroll
	 */
	const overrideScroll = () => {
		if ( disableScroll ) {
			window.scrollTo( 0, lastScroll );
		}
	};

	window.addEventListener( 'scroll', overrideScroll );

	const lb = GLightbox();

	lb.on( 'open', () => {
		lastScroll    = window.pageYOffset;
		disableScroll = true;
	} );

	lb.on( 'close', () => {
		disableScroll = false;
	} );
};

export default vFixedVideo;
